import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const priceSummaryAsync = createAsyncThunk(
  "user/priceSummary",
  async (payload, toolkit) => {
    const { packageId, couponId, addKit } = payload;

    return await AxiosClient(
      "GET",
      `/priceSummary?packageId=${packageId}&couponId=${couponId || ""}&addKit=${addKit}`,
      payload,
      toolkit,
    );
  },
);
